import React, { useState, useEffect } from "react";
import { requestAuthGet, requestAuthDelete } from "../api/authInstance";
import Header from "../components/Header";
import ModalUser from "../components/Modal/ModalUser";
import ModalDelete from "../components/Modal/ModalDelete";
import { useTranslation } from "react-i18next";
import { BankData } from "../data/BankData";
import useAPI from "../hooks/useAPI";
import _ from "lodash";
import withAuth from "../components/withAuth";
import { useAuth } from "../components/auth/authContext";
import CardUser from "../components/Card/CardUser";
import Container from "../components/Container/Container";

const UserManagement = ({ allowed_permissions }) => {
  const { userData, fetchAuthData } = useAuth();
  const { t } = useTranslation();
  const [users, loading, fetchUsers] = useAPI("/users", {
    applicationType: "WALLET",
    retailer: userData?.outlet?.retailer?.id,
    walletAdmin: false,
    limit: 10000,
  });
  const [outlets] = useAPI("/outlets", {
    retailer: userData?.outlet?.retailer?.id,
    limit: 10000,
  });

  const [roles] = useAPI("/role", {
    applicationType: "WALLET",
    limit: 10000,
  });

  const [type, setType] = useState("");
  const [data, setData] = useState({});

  const [user, setUser] = useState(
    JSON.parse(localStorage.getItem("dompet_user")),
  );

  // state input user
  const [inputUser, setInputUser] = useState({});

  const [validationUsers, setValidationUsers] = useState({
    email: {
      validate: true,
      message: "",
    },
    phone: {
      validate: true,
      message: "",
    },
    general: {
      validate: true,
      message: "",
    },
  });

  const [inputBank, setInputBank] = useState({});
  const [optionsData, setOptionsData] = useState({
    outlets: [],
    banks: [],
  });
  const [isBannerShow, setIsBannerShow] = useState({
    renew_bank_data: false,
    disable_change_data: user?.user_type === "member",
  });

  // state loading
  const [buttonLoading, setButtonLoading] = useState(false);

  // modal state
  const [showDeleteConfirmationModalUser, setShowDeleteConfirmationModalUser] =
    useState(false);

  const [showModalUser, setShowModalUser] = useState(false);

  useEffect(() => {
    GetAllDataRequire();
  }, []);

  useEffect(() => {
    if (showModalUser === false) {
      setInputUser({});
      setValidationUsers({
        email: {
          validate: true,
          message: "",
        },
        phone: {
          validate: true,
          message: "",
        },
        general: {
          validate: true,
          message: "",
        },
      });
    }
  }, [showModalUser]);

  async function GetAllDataRequire() {
    // validate user only user admin or master
    if (userData?.role?.walletAdmin) {
      try {
        // GET Bank Data
        await GetDataBank();
      } catch (error) {
        console.error(error);
      }
    }
  }

  async function GetDataBank() {
    try {
      // Get data bank details
      let bank = await requestAuthGet(`/bank-account`, {
        params: { retailer: userData?.outlet?.retailer?.id },
      });
      if (bank.data.data[0]) {
        bank = bank.data.data[0];
      }
      setInputBank((prevState) => ({
        ...prevState,
        bank_account_id: bank.bank_account_id,
        bankName: bank.bankName,
        accountNumber: bank.accountNumber,
        name: bank.name,
      }));
      // SET bank options
      setOptionsData((prevState) => ({
        ...prevState,
        banks: BankData.map((value) => ({
          label: value.name,
          value: value.id,
        })),
      }));
      // set logic show banner require renew bank data
      setIsBannerShow((prevState) => ({
        ...prevState,
        renew_bank_data: _.isEmpty(
          BankData.filter((option) => option.channel_code === bank.bankName),
        ),
      }));
    } catch (error) {
      console.error(error);
    }
  }

  function ShowEditModal(data) {
    setData({
      ...data,
      profile: {
        ...data.profile,
        phone: data?.profile?.phone
          ? data?.profile?.phone.startsWith("628")
            ? data?.profile?.phone.replace(/^628/, "8")
            : data?.profile?.phone
          : "",
      },
    });
    setShowModalUser(true);
    setType("edit");
  }

  function ShowDeleteModal(id) {
    setData({ id });
    setShowDeleteConfirmationModalUser(true);
  }

  async function DeleteUser() {
    setButtonLoading(true);
    try {
      const response = await requestAuthDelete(`users/${data.id}`);
      if (response.data.err) {
        setValidationUsers((prevState) => ({
          ...prevState,
          general: {
            validate: false,
            message: t("profile.failedDeleteMsg"),
          },
        }));
        return;
      }
    } catch (error) {
      setValidationUsers((prevState) => ({
        ...prevState,
        general: {
          validate: false,
          message: t("profile.failedDeleteMsg"),
        },
      }));
      console.error(error);
    }

    fetchUsers();
    setButtonLoading(false);
    setShowDeleteConfirmationModalUser(false);
  }

  return (
    <>
      {/* Modal Delete User */}
      <ModalDelete
        title="User"
        showDeleteConfirmationModal={showDeleteConfirmationModalUser}
        setShowDeleteConfirmationModal={setShowDeleteConfirmationModalUser}
        DeleteFunction={DeleteUser}
        buttonLoading={buttonLoading}
      />

      {/* Modal Add Outlet */}

      {/* Modal ADD USER */}
      <ModalUser
        propsModal={{ title: "Member", type, data, setData, outlets, roles }}
        setData={setData}
        data={data}
        showModal={showModalUser}
        setShowModal={setShowModalUser}
        fetchUsers={fetchUsers}
      />
      <Header
        title={t("profile.header")}
        rightButton={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setData({});
          setType("add");
          setShowModalUser(true);
        }}
        rightButtonIcon={
          <svg
            className="h-4 w-4 flex-shrink-0 fill-current"
            viewBox="0 0 16 16"
          >
            <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
          </svg>
        }
      />
      <div className="min-h-dvh bg-monochrome-25 px-4 py-20">
        <Container>
          <div className="space-y-5">
            <div>
              <div className="mt-4">
                <div className="space-y-3">
                  {_.isEmpty(users) ? (
                    <div className="h-28 w-full border-2 border-dashed">
                      <div className="flex h-full w-full items-center justify-center space-x-2 text-gray-400">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13.3327 2.8898C14.5674 3.50343 15.416 4.77762 15.416 6.25C15.416 7.72238 14.5674 8.99657 13.3327 9.6102M14.9993 13.972C16.2589 14.5419 17.3931 15.4708 18.3327 16.6667M1.66602 16.6667C3.28809 14.6021 5.49033 13.3333 7.91602 13.3333C10.3417 13.3333 12.5439 14.6021 14.166 16.6667M11.666 6.25C11.666 8.32107 9.98708 10 7.91602 10C5.84495 10 4.16602 8.32107 4.16602 6.25C4.16602 4.17893 5.84495 2.5 7.91602 2.5C9.98708 2.5 11.666 4.17893 11.666 6.25Z"
                            stroke="currentColor"
                            strokeWidth="1.66667"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <span className="text-sm text-gray-400">
                          {t("profile.emptyUser")}
                        </span>
                      </div>
                    </div>
                  ) : !loading ? (
                    users.map((user, index) => (
                      <CardUser
                        key={index}
                        data={user}
                        enActionEdit={userData?.role?.walletAdmin}
                        enActionDelete={userData?.role?.walletAdmin}
                        isDisable={false}
                        editFunction={ShowEditModal}
                        deleteFunction={ShowDeleteModal}
                      />
                    ))
                  ) : (
                    Array(3)
                      .fill(0)
                      .map((_, index) => (
                        <div
                          key={index}
                          className="rounded-lg border border-gray-200 p-3 shadow-sm"
                        >
                          <div className="animate-pulse">
                            <div className="col-span-4 flex flex-col justify-between space-y-4">
                              <div className="my-2 h-6 w-32 rounded-md bg-monochrome-100"></div>
                              <div className="mb-2 h-3 w-full rounded-md bg-monochrome-100"></div>
                              <div className="mb-2 h-3 w-full rounded-md bg-monochrome-100"></div>
                              <div className="mb-2 h-3 w-full rounded-md bg-monochrome-100"></div>
                              <div className="h-3 w-48 rounded-md bg-monochrome-100"></div>
                              <div className="items flex justify-between">
                                <div className="h-6 w-32 rounded-md bg-monochrome-100"></div>
                                <div className="h-6 w-32 rounded-md bg-monochrome-100"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                  )}
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};

export default withAuth(UserManagement);
